import { render, staticRenderFns } from "./ModalRejectAttributionReason.vue?vue&type=template&id=784c3aa8"
import script from "./ModalRejectAttributionReason.vue?vue&type=script&lang=js"
export * from "./ModalRejectAttributionReason.vue?vue&type=script&lang=js"
import style0 from "./ModalRejectAttributionReason.vue?vue&type=style&index=0&id=784c3aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports